import { render } from "./user-integration.vue?vue&type=template&id=50f98b59"
import script from "./user-integration.vue?vue&type=script&lang=js"
export * from "./user-integration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__